<div class="dcs-page" *ngIf="!loading && check">
    <div class="dcs-header">
        <div class="dcs-header-left">
            <button type="button" class="dcs-back-arrow" (click)="goBack()"><img src="assets/img/departure-check/icon-back-arrow.svg" alt="Regresar"></button>
            <p class="dcs-title">Resumen del check</p>
        </div>
        <button type="button" class="dcs-download-btn" (click)="downloadPdf()">Descargar PDF</button>
    </div>

    <div class="dcs-table">
        <div class="dcs-row">
            <div class="dcs-row-header"><span>Datos del servicio</span><strong class="dcs-ok">Completado</strong></div>
        </div>
        <div class="dcs-divider"></div>

        <div class="dcs-row">
            <div class="dcs-row-header">
                <span>Estado de la unidad</span>
                <strong class="dcs-ok">
                    {{(check.damage_points || []).length}} daños registrados
                </strong>
            </div>
            <div class="dcs-row-body">
                <app-vehicle-damage-diagram [points]="check.damage_points || []" [readonly]="true"></app-vehicle-damage-diagram>
            </div>
        </div>
        <div class="dcs-divider"></div>

        <div class="dcs-row">
            <div class="dcs-row-header"><span>Combustible y odómetro</span><strong class="dcs-ok">{{check.fuel_level}}% tanque - {{check.mileage}} km</strong></div>
            <div class="dcs-row-body">
                <div class="dcs-fuel-row">
                    <div class="dcs-fuel-dial-col">
                        <div class="dcs-fuel-dial-wrap">
                            <img class="dcs-fuel-dial-bg" src="assets/img/departure-check/fuel-gauge-bg.svg" alt="">
                            <svg class="dcs-fuel-needle-svg" viewBox="0 0 227 129">
                                <line class="dcs-fuel-needle" x1="114" y1="128" x2="114" y2="15"
                                    [attr.transform]="'rotate(' + needleAngle + ' 114 128)'"></line>
                                <circle cx="114" cy="128" r="7" fill="#00a0e1"></circle>
                            </svg>
                        </div>
                        <div class="dcs-fuel-slider-track">
                            <div class="dcs-fuel-slider-fill" [style.width.%]="check.fuel_level"></div>
                            <div class="dcs-fuel-slider-thumb" [style.left.%]="check.fuel_level"></div>
                        </div>
                    </div>
                    <div class="dcs-odometer-wrap">
                        <img *ngIf="photoUrl('odometro')" [src]="photoUrl('odometro')" alt="Odómetro" class="dcs-odometer-img">
                    </div>
                </div>
            </div>
        </div>
        <div class="dcs-divider"></div>

        <div class="dcs-row">
            <div class="dcs-row-header"><span>Funcionamiento</span><strong class="dcs-ok">{{funcionamientoOkCount}}/{{funcionamientoLabels.length}} - {{funcionamientoOkCount === funcionamientoLabels.length ? 'OK' : 'Revisar'}}</strong></div>
            <div class="dcs-row-body dcs-funcionamiento-grid">
                <div class="dcs-funcionamiento-item" *ngFor="let f of funcionamientoLabels">
                    <img [src]="'assets/img/departure-check/' + f.icon" alt="">
                    <span>{{f.label}}</span>
                    <img class="dcs-check" src="assets/img/departure-check/icon-check-badge.svg" alt="" *ngIf="funcionamientoValue(f.key)">
                </div>
            </div>
        </div>
        <div class="dcs-divider"></div>

        <div class="dcs-row">
            <div class="dcs-row-header">
                <span>Sensores del tablero</span>
                <strong class="dcs-ok">
                    {{(check.dashboard_sensors || []).length === 0 ? 'Sin alertas' : (check.dashboard_sensors.length + ' alertas registradas')}}
                </strong>
            </div>
            <div class="dcs-row-body dcs-sensors-wrap">
                <div class="dcs-sensors-row">
                    <div class="dcs-sensor" *ngFor="let s of sensoresRow1" [class.dcs-sensor--active]="s.active" [attr.title]="s.label">
                        <img *ngIf="!s.active" [src]="'assets/img/departure-check/' + s.icon" [style.width.px]="s.w" [style.height.px]="s.h" alt="">
                        <div *ngIf="s.active" class="dcs-sensor-icon-active" [style.width.px]="s.w" [style.height.px]="s.h"
                            [ngStyle]="{'-webkit-mask-image': 'url(assets/img/departure-check/' + s.icon + ')', 'mask-image': 'url(assets/img/departure-check/' + s.icon + ')'}"></div>
                    </div>
                </div>
                <div class="dcs-sensors-row dcs-sensors-row--compact">
                    <div class="dcs-sensor" *ngFor="let s of sensoresRow2" [class.dcs-sensor--active]="s.active" [attr.title]="s.label">
                        <img *ngIf="!s.active" [src]="'assets/img/departure-check/' + s.icon" [style.width.px]="s.w" [style.height.px]="s.h" alt="">
                        <div *ngIf="s.active" class="dcs-sensor-icon-active" [style.width.px]="s.w" [style.height.px]="s.h"
                            [ngStyle]="{'-webkit-mask-image': 'url(assets/img/departure-check/' + s.icon + ')', 'mask-image': 'url(assets/img/departure-check/' + s.icon + ')'}"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dcs-divider"></div>

        <div class="dcs-row">
            <div class="dcs-row-header"><span>Evidencia fotográfica</span><strong class="dcs-ok">{{evidenciaFotos.length}}/4 fotos</strong></div>
            <div class="dcs-row-body dcs-fotos-grid" *ngIf="evidenciaFotos.length > 0">
                <div class="dcs-foto-card" *ngFor="let p of evidenciaFotos">
                    <div class="dcs-foto-card-header">
                        <p>{{fotoLabel(p.category)}}</p>
                        <span class="dcs-foto-check"><img src="assets/img/departure-check/icon-check-badge.svg" alt=""></span>
                    </div>
                    <div class="dcs-foto-card-img">
                        <img [src]="photoUrl(p.category)" [alt]="fotoLabel(p.category)">
                    </div>
                </div>
            </div>
            <div class="dcs-row-body" *ngIf="evidenciaFotos.length === 0">
                <p class="dcs-empty-text">Sin fotos registradas</p>
            </div>
        </div>
        <div class="dcs-divider"></div>

        <div class="dcs-row">
            <div class="dcs-row-header">
                <span>Documentación</span>
                <strong class="dcs-ok">
                    {{ documentosCompletas ? 'Completa' : 'Incompleta' }}
                </strong>
            </div>
            <div class="dcs-row-body dcs-documentos-list">
                <div class="dcs-documento-row" *ngFor="let doc of documentos">
                    <div class="dcs-documento-left">
                        <div class="dcs-documento-icon" [ngClass]="doc.boxClass"><img [src]="'assets/img/departure-check/' + doc.icon" alt=""></div>
                        <div class="dcs-documento-text">
                            <p class="dcs-documento-label">{{doc.label}}</p>
                            <p class="dcs-documento-subtitle">{{doc.subtitle}}</p>
                        </div>
                    </div>
                    <span class="dcs-doc-check" [class.dcs-doc-check--off]="!doc.verified">
                        <img src="assets/img/departure-check/icon-check-badge.svg" alt="">
                    </span>
                </div>
            </div>
        </div>
        <div class="dcs-divider"></div>

        <div class="dcs-row" *ngIf="check.performed_by">
            <div class="dcs-row-header"><span>Check realizado por:</span></div>
            <div class="dcs-row-body">
                <div class="dcs-documento-row">
                    <div class="dcs-documento-left">
                        <div class="dcs-documento-icon dc-doc-box--blue"><img src="assets/img/departure-check/icon-user.svg" alt=""></div>
                        <div class="dcs-documento-text">
                            <p class="dcs-documento-label">{{check.performed_by.name}}</p>
                            <p class="dcs-documento-subtitle">{{check.performed_by.role}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="dcs-observaciones-card" *ngIf="check.general_observations">
        <p class="dcs-observaciones-title">Observaciónes generales</p>
        <p class="dcs-observations-text">{{check.general_observations}}</p>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
